import {inject, Pipe, PipeTransform} from "@angular/core";
import {UserService} from "../../services/user.service";
import {CookieService} from "ngx-cookie-service";
import {SelectionService} from "../../services/selection.service";
import {Userrole} from "../../shared/interfaces/user";

@Pipe({
  name: "workplaceFilter",
})
export class WorkplaceFilterPipe implements PipeTransform {
  userService = inject(UserService);
  cookieService = inject(CookieService);
  selectionService = inject(SelectionService);
  productionLine: string;
  Userrole = Userrole;

  transform(workplaces: any): any {
    if (this.userService.userrole() === Userrole.Mitarbeiter) {
      let currentWorkplace = this.cookieService.get("workplace").split("%")[0];
      return workplaces.filter(
        (workplace: any) => workplace.id === currentWorkplace
      );
    } else if (
      this.userService.userrole() === Userrole.Teamleiter ||
      this.userService.userrole() === Userrole.Schichtleiter
    ) {
      let productionLineUuid = this.userService
        .user()
        ?.app_metadata?.["productionLine"].split("%")[0];

      return workplaces.filter(
        (workplace: any) => workplace.production_line === productionLineUuid
      );
    } else {
      return workplaces;
    }
  }
}
